export enum TextOutlineStyle {
  "full" = "full",
  "round" = "round",
}
